import { nanoid } from "nanoid"

const publicPermissions = {

    collection: {
        key: 'collection',
        label: '{{lang}}ca.collection',
        permissions: {
            record: {
                key: 'record', label: '{{lang}}ca.record',
                subPermissions: {
                    view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
                    create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
                    edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
                    delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
                }
            }
        },
    },
    automation: {
        key: 'automation',
        label: '{{lang}}ca.automation',
        subPermissions: {
            view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
            create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
            edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
            delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
        },
    },
    actions: {
        key: 'actions',
        label: '{{lang}}ca.actions',
        revise: {
            key: 'revise', label: '{{lang}}ca.Can Revise',
            subPermissions: {
                view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
                create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
                edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
                delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
            },
        },
        changeStage: {
            key: 'changeStage', label: '{{lang}}ca.Change Stage',
            subPermissions: {
                view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
                create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
                edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
                delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
            },
        },
    },
}
const databasePermissions = {

    main: {
        key: 'main',
        label: '{{lang}}ca.Main',
        permissions: {
            // userPerspective: {
            //     key: 'userPerspective',
            //     label: '{{lang}}ca.user perspective',
            //     subPermissions: {
            //         view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
            //         create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
            //         edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
            //         delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
            //     },
            // },
            // collection: {
            //     key: 'collection',
            //     label: '{{lang}}ca.collection',
            //     subPermissions: {
            //         view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
            //         create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
            //         edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
            //         delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
            //     },
            // },
            customFields: {
                key: 'customFields',
                label: '{{lang}}ca.Custom Fields',
                subPermissions: {
                    add: { key: 'add', title: '{{lang}}add', main: true, condition: {} },
                    edit: { key: 'edit', title: '{{lang}}edit', main: true, condition: {} },
                    delete: { key: 'delete', title: '{{lang}}delete', main: true, condition: {} },
                },
            },
            view: {
                key: 'view',
                label: '{{lang}}ca.View',
                subPermissions: {
                    create: { key: 'create', title: '{{lang}}create', main: true, condition: {} },
                    edit: { key: 'edit', title: '{{lang}}edit', main: true, condition: {} },
                    delete: { key: 'delete', title: '{{lang}}delete', main: true, condition: {} },
                },
            },
            viewRecord: { key: 'viewRecord', label: '{{lang}}ca.view Record', disabled: true },
            addNewRecord: { key: 'addNewRecord', label: '{{lang}}ca.addNew Record' },
            editRecord: { key: 'editRecord', label: '{{lang}}ca.edit Record' },
            customizeFields: { key: 'customizeFields', label: '{{lang}}ca.customize Fields' },
            saveFilter: { key: 'saveFilter', label: '{{lang}}ca.save Filter' },
            viewActivityLogs: { key: 'viewActivityLogs', label: '{{lang}}ca.view Activity Logs' },
            conditionalFormat: { key: 'conditionalFormat', label: '{{lang}}ca.conditional Format' },
            // page: {
            //     key: 'page',
            //     label: '{{lang}}ca.page',
            //     subPermissions: {
            //         view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
            //         create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
            //         edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
            //         delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
            //     },
            // },
            
        }
    },
    // collection: publicPermissions.collection,
    settings: {
        key: 'settings',
        label: '{{lang}}ca.Settings',
        permissions: {
            automation: publicPermissions.automation,
            inviteHub: { key: 'inviteHub', label: '{{lang}}ca.invite Hub' },
            editCollectionInfo: { key: 'editCollectionInfo', label: '{{lang}}ca.edit Collection Info' },
            editPermissions: { key: 'editPermissions', label: '{{lang}}ca.edit Permissions' },

        }
    },


}
const inquiryPermissions = {

    main: {
        key: 'main',
        label: '{{lang}}ca.Main',
        permissions: {
            // userPerspective: {
            //     key: 'userPerspective',
            //     label: '{{lang}}ca.user perspective',
            //     subPermissions: {
            //         view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
            //         create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
            //         edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
            //         delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
            //     },
            // },
            // collection: {
            //     key: 'collection',
            //     label: '{{lang}}ca.collection',
            //     subPermissions: {
            //         view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
            //         create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
            //         edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
            //         delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
            //     },
            // },
            customFields: {
                key: 'customFields',
                label: '{{lang}}ca.Custom Fields',
                subPermissions: {
                    add: { key: 'add', title: '{{lang}}add', main: true, condition: {} },
                    edit: { key: 'edit', title: '{{lang}}edit', main: true, condition: {} },
                    delete: { key: 'delete', title: '{{lang}}delete', main: true, condition: {} },
                },
            },
            view: {
                key: 'view',
                label: '{{lang}}ca.View',
                subPermissions: {
                    create: { key: 'create', title: '{{lang}}create', main: true, condition: {} },
                    edit: { key: 'edit', title: '{{lang}}edit', main: true, condition: {} },
                    delete: { key: 'delete', title: '{{lang}}delete', main: true, condition: {} },
                },
            },
            viewRecord: { key: 'viewRecord', label: '{{lang}}ca.view Record', disabled: true },
            addNewRecord: { key: 'addNewRecord', label: '{{lang}}ca.addNew Record' },
            editRecord: { key: 'editRecord', label: '{{lang}}ca.edit Record' },
            customizeFields: { key: 'customizeFields', label: '{{lang}}ca.customize Fields' },
            saveFilter: { key: 'saveFilter', label: '{{lang}}ca.save Filter' },
            viewActivityLogs: { key: 'viewActivityLogs', label: '{{lang}}ca.view Activity Logs' },
            conditionalFormat: { key: 'conditionalFormat', label: '{{lang}}ca.conditional Format' },
            // page: {
            //     key: 'page',
            //     label: '{{lang}}ca.page',
            //     subPermissions: {
            //         view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
            //         create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
            //         edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
            //         delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
            //     },
            // },
            
        }
    },
    // collection: publicPermissions.collection,
    settings: {
        key: 'settings',
        label: '{{lang}}ca.Settings',
        permissions: {
            automation: publicPermissions.automation,
            inviteHub: { key: 'inviteHub', label: '{{lang}}ca.invite Hub' },
            editCollectionInfo: { key: 'editCollectionInfo', label: '{{lang}}ca.edit Collection Info' },
            editPermissions: { key: 'editPermissions', label: '{{lang}}ca.edit Permissions' },

        }
    },


}
const taskPermissions = {

    main: {
        key: 'main',
        label: '{{lang}}ca.Main',
        permissions: {
            userPerspective: {
                key: 'userPerspective',
                label: '{{lang}}ca.user perspective',
                subPermissions: {
                    view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
                    create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
                    edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
                    delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
                },
            },
            // collection: {
            //     key: 'collection',
            //     label: '{{lang}}ca.collection',
            //     subPermissions: {
            //         view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
            //         create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
            //         edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
            //         delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
            //     },
            // },
            page: {
                key: 'page',
                label: '{{lang}}ca.page',
                subPermissions: {
                    view: { key: 'view', title: '{{lang}}view', main: true, condition: {} },
                    create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true, condition: {} },
                    edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true, condition: {} },
                    delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true, condition: {} },
                },
            },
            addNewRecord: { key: 'addNewRecord', label: '{{lang}}ca.addNewRecord' }
        }
    },
    collection: publicPermissions.collection,
    settings: {
        key: 'settings',
        label: '{{lang}}ca.Settings',
        permissions: {
            automation: publicPermissions.automation,
        }
    },


}

const messengerPermissions = {
    main: {
        key: 'main',
        label: '{{lang}}ca.Main',
        permissions: {
            postMessage: { key: 'postMessage', label: '{{lang}}ca.Post Message' },
            editMessageOfOthers: { key: 'editMessageOfOthers', label: '{{lang}}ca.Edit Message Of Others' },
            deleteMessageOfOthers: { key: 'deleteMessageOfOthers', label: '{{lang}}ca.Delete Message Of Others' },
            invitUsersViaLink: { key: 'invitUsersViaLink', label: '{{lang}}ca.Invite Users Via Link' },
            manageVideoChats: { key: 'manageVideoChats', label: '{{lang}}ca.Manage Video Chats' },
            editApplet: { key: 'editApplet', label: '{{lang}}ca.Edit Applet', },
            editPermissions: { key: 'editPermissions', label: '{{lang}}ca.Edit Permissions' },
        }
    }
}

// const deskCollection = [{ id: nanoid(), name: 'voucher' }, { id: nanoid(), name: 'order' }]
const commerceCollection = [{ _id: 'voucher', name: 'voucher' }, { _id: 'order', name: 'order' }]
export { publicPermissions, databasePermissions, messengerPermissions, commerceCollection, taskPermissions,inquiryPermissions }